export const skillGroups = [
  {
    name: "Languages",
    items: ["JavaScript", "Python", "Java", "TypeScript", "Dart"],
  },
  {
    name: "Frameworks & libraries",
    items: ["React", "React Native", "Node.js", "Express", "Flutter", "FastAPI"],
  },
  {
    name: "Databases & tools",
    items: ["MongoDB", "PostgreSQL", "Firebase", "AWS S3", "MySQL"],
  },
  {
    name: "Design & Tools ",
    items: ["Figma", "Material-UI", "TailwindCSS", "Git", "Jira"],
  },
];
